import * as angular from "angular";
import { informationTab } from "../information-tab";
import template from "./view-export-information-tab.html";
import type { ModalTabItem } from "../../../../components/modals/tabbed-modal/tabbed-modal-types";

export interface ViewExportInformationTabController {
	exportLog?: unknown;
}

// eslint-disable-next-line no-redeclare
export class ViewExportInformationTabController {
	public readonly tab: ModalTabItem = {
		name: "Information",
		code: "INFORMATION"
	};
}

export default angular
	.module("vesl.components.exports.view-export.tabs.information", [informationTab])
	.component("viewExportInformationTab", {
		controller: ViewExportInformationTabController,
		template,
		bindings: {
			exportLog: "<"
		}
	})
	.name;
